export enum WireExcessType {
  Standard = 'Standard',
  Additional = 'Additional',
  Building = 'Building',
  Contents = 'Contents',
}

export type WireExcess = {
  id: string;
  code?: string;
  name?: string;
  type: WireExcessType;
  amount: number;
  selected?: boolean;
};
